import { HomeQuestionReviewPage } from './HomeQuestionReviewPage';
export default HomeQuestionReviewPage;